// import { eLayout } from "@/map/utils/basecore";

// const limitLayout = [
//     eLayout.FishLeft,
//     eLayout.FishLeftDown,
//     eLayout.FishLeftUp,
//     eLayout.FishRight,
//     eLayout.FishRightDown,
//     eLayout.FishRightUp,

//     eLayout.TimeBottom,
//     eLayout.TimeRight,
//     eLayout.TimeRightTurn,
//     eLayout.TimeTreeDown,
//     eLayout.TimeTreeUp,

//     eLayout.Sector,
//     eLayout.Bubble,
//     eLayout.Circle
// ];

//判断当前会员等级（level)对该操作类型(type,flag)有无权限
//payload:{vip,type,flag}
export default function viplimit(payload) {
    let { vip, type, flag } = payload,
        limit = "pass";
    if (!vip) {
        switch (type) {
            //限制导出、打印、会员免费
            default:
            case "output":
            case "mfree":
            case "cmfree":
            case "encrypt":
            case "dropbox":
            case "googledrive":
            case "download":
            case "history":
            case "newLib":
            case "openLib":
            case "addImgToLib":
            case "addPage":
            case "team":
            case "addRecycle":
            case "cloudSpace":
            case "cloudSpaceVIP":
            case "playSlide":
            case "pageBackgroundColor":
            case "print": {
                limit = type;
                break;
            }
            //限制主题
            case "theme": {
                if ([1, 2, 3, 31, 32, 33].indexOf(Number(flag)) == -1) limit = type;
                break;
            }
        }
    }
    return limit;
}
